<template>
  <div class="molecule-node-list_container">
    <molecule-filter-tag
      :tagsList="tagsList"
      @messageFilter="filterMessage"
      @selectTagList="filterTag"
      class="filter-tag--padding mb-1"
    ></molecule-filter-tag>
    <molecule-select-node
      :listData="filteredNodeList"
      @checkedListData="checkedListData"
      @selectedNode="selectedNode"
    ></molecule-select-node>
  </div>
</template>

<script>
import MoleculeFilterTag from "@/components/molecules/MoleculeFilterTag.vue"
import MoleculeSelectNode from "@/components/molecules/networkConfigurationManagement/MoleculeSelectNode.vue"
export default {
  name: "MoleculeNodeList",
  components: {
    MoleculeFilterTag,
    MoleculeSelectNode,
  },
  props: {
    nodeList: {
      type: Array,
      required: false,
      default: () => [],
    },
    tagsList: {
      type: Array,
      required: true,
    },
  },
  emits: ["checkedListData", "selectedNode"],
  data() {
    return {
      filteredMessageNodeList: [],
      filteredTagNodeList: [],
      filteredNodeList: [],
      bufferMessageFilter: "",
      bufferTagList: [],
    }
  },
  watch: {
    nodeList: {
      deep: true,
      handler() {
        this.filteredNodeList = this.nodeList
        this.filterNode()
      },
    },
    bufferMessageFilter() {
      if (this.bufferMessageFilter === "" && this.bufferTagList.length === 0) {
        this.filteredNodeList = this.nodeList
      } else {
        this.filterNode()
      }
    },
    bufferTagList() {
      if (this.bufferMessageFilter === "" && this.bufferTagList.length === 0) {
        this.filteredNodeList = this.nodeList
      } else {
        this.filterNode()
      }
    },
  },
  methods: {
    filterNode() {
      if (this.bufferMessageFilter === "" && !this.bufferTagList.length) {
        this.filteredNodeList = this.nodeList
      } else if (this.bufferMessageFilter === "") {
        this.filteredNodeList = this.filteredTagNodeList
      } else if (this.bufferTagList.length === 0) {
        this.filteredNodeList = this.filteredMessageNodeList
      } else {
        this.filteredNodeList = this.filteredMessageNodeList.filter((value) =>
          this.filteredTagNodeList.includes(value)
        )
      }
    },
    filterMessage(messageFilter) {
      this.bufferMessageFilter = messageFilter.toLowerCase()
      this.filteredMessageNodeList = []
      for (var i = 0; i < this.nodeList.length; i++) {
        if (this.checkSubString(this.nodeList[i], messageFilter)) {
          this.filteredMessageNodeList.push(this.nodeList[i])
        }
      }
    },
    filterTag(tagsList) {
      this.bufferTagList = tagsList
      this.filteredTagNodeList = []
      for (var i = 0; i < this.nodeList.length; i++) {
        if (this.checkTagList(this.nodeList[i], tagsList)) {
          this.filteredTagNodeList.push(this.nodeList[i])
        }
      }
    },
    checkSubString(list, subString) {
      return (
        list.hostname.includes(subString) ||
        list.hostname.toLowerCase().includes(subString.toLowerCase()) ||
        list.hostname.toUpperCase().includes(subString.toUpperCase())
      )
    },
    checkTagList(list, tagsList) {
      let haveTag = true
      tagsList.forEach((tag) => {
        if (!list.tags.find((node) => node === tag)) haveTag = false
      })
      return haveTag
    },
    checkedListData(checkedListData) {
      this.$emit("checkedNodeList", checkedListData)
    },
    selectedNode(selectedNode) {
      this.$emit("selectedNode", selectedNode)
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-tag--padding {
  padding-left: 15px;
  padding-right: 15px;
}
</style>
